import React from "react";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../commons/functions/generalFunctions";
import "./styles.css";
import { Card } from "semantic-ui-react";
const moment = require("moment-timezone");
const zone_name = moment.tz.guess();
moment.tz.setDefault(zone_name);

const HistoryItem = ({ item, toggle, index }) => {
  return (
    <div className="history-item-container">
      <button
        type="button"
        className="history-item-button"
        onClick={() => toggle(index)}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="card-body text-left">
                <h5
                  className="card-title"
                  style={{ fontWeight: "bold" }}
                >{`ID. Factura: ${item.invoiceNumber}`}</h5>
                <p className="card-text">{`Dirección de envío: ${
                  item.shipping.addressLine1 && item.shipping.addressLine1
                }, ${
                  item.shipping.addressLine2 && item.shipping.addressLine2
                }`}</p>
                <p>
                  {`Total de artículos comprados: ${item.orderHistory.length}`}
                </p>
                <p className="mr-3">
                  Total de la compra:{" "}
                  {
                    <span className="history-item-price">
                      {item.currency === "USD"
                        ? formatterUSD.format(
                            parseFloat(
                              item.usdTotal ? item.usdTotal : item.total
                            )
                          )
                        : formatCurrency(parseFloat(item.total))}
                    </span>
                  }
                </p>
              </div>
            </div>
            <div className="col-md-4" style={{ padding: 15 }}>
              <Card.Group
                className="history-item-card-group"
                itemsPerRow={
                  item.orderHistory.length % 2
                    ? item.orderHistory.length === 1
                      ? item.orderHistory.length
                      : 2
                    : item.orderHistory.length / 2
                }
              >
                {item.orderHistory.map((product, key) => (
                  <Card
                    key={key}
                    raised
                    style={{
                      backgroundImage: `url(${product.image})`,
                      display: "flex",
                      backgroundSize: "cover",
                      objectFit: "cover",
                      backgroundPosition: "center",
                      height: 100,
                      width: 100,
                    }}
                  />
                ))}
              </Card.Group>
            </div>
          </div>
        </div>
      </button>
      <div className="card-footer text-muted">
        {moment(item.date).format("LLL")}
      </div>
    </div>
  );
};

export default HistoryItem;
